import { ElementType, ReactNode } from 'react';
import { FormikProps } from 'formik';
import * as Yup from 'yup';

export interface StepField {
  name: string;
  label: string;
  value: string | null | undefined | boolean | number | ReactNode;
}

export interface StepSection {
  title?: string;
  fields: StepField[];
}

export enum StepId {
  CONFIGURATION = 'configuration',
  ENV_VARS = 'envVars',
  TOPOLOGY = 'topology',
  BOOTSTRAP = 'bootstrap',
  SUMMARY = 'summary',
  MAIN_SETTINGS = 'mainSettings',
  CLUSTER_CONFIG = 'clusterConfig',
  CLUSTER_PARTICIPANT_CONFIG = 'clusterParticipantConfig',
  RESOURCES_CONFIG = 'resourceConfig',
}

export type StepConfig = {
  [key in StepId]?: StepSection[];
};

export type Step = {
  id: StepId;
  label: string;
  component: ElementType;
  validationSchema?: Yup.Schema;
};

export interface DefaultStepProps<T> {
  form: FormikProps<T>;
}

export type TStepperProps = {
  steps: Step[];
  currentIndex: number;
  goNext: () => void;
  goBack: () => void;
  children: ReactNode;
};

export type ServerErrors = {
  [key in StepId]?: { [key: string]: string | object };
};
